import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LightingUpAngularModule } from 'lighting-up-angular';
import { DonneesPatientCVComponent } from './donnees-patient-cv.component';
import { PipeANAKINModule } from '../../pipe/pipeAnakin.module';

@NgModule({
	declarations: [DonneesPatientCVComponent],
	imports: [CommonModule, LightingUpAngularModule, PipeANAKINModule],
	exports: [DonneesPatientCVComponent]
})
export class DonneesPatientCVModule { }
